// Guided-tour registry. Each tour: { id, version, title, icon, duration, scope?,
// available(), readySelector?, autoInvite?, inviteDelay?, invite?, contextual?, steps[] }.
// Bump a tour's `version` when its steps change materially, so it is offered again.
import partsFinder from './parts-finder.js';
import myGarage from './my-garage.js';
import branchSelector from './branch-selector.js';
import returns from './returns.js';
import { signIn, register } from './account.js';

export var TOURS = [partsFinder, myGarage, returns, signIn, register, branchSelector];
